/**
 * Global failure hooks — Guardrail 10's "nothing fails silently" applied to the
 * failures nobody wrote a handler for.
 *
 * An unhandled rejection in a browser is invisible: no dialog, no console for an
 * installed PWA, nothing. These two hooks are the difference between "the app is
 * weird sometimes" and a diagnosable report.
 */
import { ledger } from './browser.js';

export type Notifier = (message: string) => void;

export function installGlobalHooks(notify: Notifier): void {
  window.addEventListener('error', (event) => {
    const entry = ledger.record(event.error ?? event.message, 'window.onerror', { notified: true });
    notify(entry.userMessage);
  });

  window.addEventListener('unhandledrejection', (event) => {
    const entry = ledger.record(event.reason, 'unhandledrejection', { notified: true });
    notify(entry.userMessage);
  });
}
